export default [
  { href: '/', title: 'Home', icon: 'icon-home', big: true },
  { divider: true },
  { href: '/about', title: 'About', icon: 'icon-version' }
]
